import React from 'react';
import { Alert } from '@timeedit/ui-components/antd';

const RawFieldMapping = () => (
  <Alert
    type="info"
    title="No further action needed"
    description="The application will automatically receive the first primary field from TE Server"
  />
);

export default RawFieldMapping;
